import mod from "-!./home.js?vue&type=script&lang=js&"; export default mod; export * from "-!./home.js?vue&type=script&lang=js&"